 query TripNotesData($id: UUID!) {
 tripItem(id:$id){
 notesByEntityId(orderBy:_CREATED_DATE_ASC)
  {
       nodes {
            id
            _createdByUserName
            _createdDate
            noteComment
            isShared
            _isUpdatable
            _rowTimestamp
            _isDeletable
          }
  }
          }
  }
        
    
  
  

  
 